import React from 'react'
// Service axios
import api from '../../../apiClient/v1'
//CSS
import css from '../FondosAsignados.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)
//Componentes
import { TablaFondosAsignados } from './TablaFondosAsignados.jsx'

export class FondosAsignados extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            fondos: []
        }
    }
    componentWillMount(){
        api.rendiciones().misRendiciones()
            .then(fondos=>{
                this.setState({fondos})
            })
            .catch(err=>{
                console.log(err)
            })
    }
    render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="panel panel-default">
                        <div className="panel-body">
                            <div className="page-header row">
                                <div className={cx("col-md-12", 'titleMyFinancing')}>
                                    <div className={cx("col-md-10", 'divTitle')}>
                                        <h3><span className="glyphicon glyphicon-briefcase"></span> Fondos Asignados</h3>
                                    </div>
                                </div>
                            </div>
                            {this.state.fondos.length === 0 ?
                                null
                                :
                                <div className={cx("row", 'divFinancing')}>
                                    <div className="col-md-12">
                                        <h5 className={css.textInformation}>Listado de fondos asignados*</h5>
                                    </div>
                                    <div className="col-md-12">
                                        <TablaFondosAsignados
                                            fondos={this.state.fondos}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/operarios/fondos-asignados/fondos/FondosAsignados.jsx